import { connect } from 'react-redux';
import React, { useState, useRef, useEffect } from 'react';
import TextInput from 'app/Components/Shared/TextInput/TextInput';
import { formatPhoneNumber } from 'app/utilities/StringHelpers/StringHelpers';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import {
    createOtpLoginStep02,
    createOtpLoginStep1,
    saveDumbLogin
} from 'app/utilities/authentication/authenticationSlice';
import { hideAppLoader, showAppLoader } from 'app/Components/Shared/Loader/LoaderSlice';
import { refetchData } from 'app/Components/Page/SelfCarePage/SelfCareSlice';
import { getSelfCareData } from 'app/Components/Block/WelcomeBlock/welcomeBlockSlice';
import Loader from 'app/Components/Shared/Loader/Loader';
import { rolesKeys } from 'app/Components/Block/OTPLoginBlock/Assets/variables';
import { isMobile } from 'react-device-detect';

const PopUpStates = {
    SEND_CODE: 'sendCode',
    VALIDATE_CODE: 'validateCode'
};

function OtpExtendedPopUp(props) {
    const [state, setState] = useState({
        code: '',
        restrictCode: '',
        errorInForm: '',
        currentPopUp: PopUpStates.SEND_CODE,
        contactNumber: '',
        needRestrictCode: false,
        ticketId: ''
    });

    const codeRef = useRef();
    const restrictCodeRef = useRef();

    useEffect(() => {
        return () => {
            resetState();
        }
    }, []);

    const resetState = () => {
        setState({
            code: '',
            restrictCode: '',
            errorInForm: '',
            currentPopUp: PopUpStates.SEND_CODE,
            contactNumber: '',
            needRestrictCode: false,
            ticketId: ''
        });
    };

    const sendSmsToContact = async () => {
        props.showAppLoader();
        try {
            const res = await props.createOtpLoginStep1({ phoneNumber: props.userDetails.contactNumber, isExtended: true });
            const body = res.payload.Body;
            if (body.isSuccess) {
                setState((prevState) => ({
                    ...prevState,
                    contactNumber: body.extra.contactNumber,
                    ticketId: body.message,
                    needRestrictCode: body.resultMessage === 'OTP_RESTRICT_CODE_REQUIRE',
                    currentPopUp: PopUpStates.VALIDATE_CODE
                }));
            }
        } finally {
            props.hideAppLoader();
        }
    };

    const checkOtpStep2 = async () => {
        if (state.code) {
            props.showAppLoader();
            try {
                const res = await props.createOtpLoginStep02({
                    phoneNumber: props.userDetails.contactNumber,
                    otpCode: state.code,
                    guid: state.ticketId,
                    restrictCode: state.restrictCode,
                    termsAccepted: true,
                    checkPhoneNumber: state.contactNumber,
                    loginType: rolesKeys.OTPEXTENDED
                });
                if (res.payload?.isSuccess) {
                    props.onAuthentication();
                } else {
                    setState((prevState) => ({ ...prevState, errorInForm: 'מממ.. זה לא הקוד ששלחנו, שננסה שוב?' }));
                }
            } finally {
                props.hideAppLoader();
            }
        } else {
            setState((prevState) => ({ ...prevState, errorInForm: 'אנא הזן קוד אימות' }));
        }
    };

    const getCurrentPopUp = () => {
        if (props.isOtpExtendedAuthenticated && props.isLoadingExtendedData) {
            return loadingNewData();
        }
        return state.currentPopUp === PopUpStates.SEND_CODE ? SendCode() : validateCode();
    };

    const loadingNewData = () => (
        <div className='loadingNewData'>
            <p className='title'>{props.loadingText}</p>
            <Loader />
        </div>
    );

    const closePopUp = (
        <p className='purpleText' onClick={() => props.setShowPopUp(false)}>
            {props.closeText}
        </p>
    );

    const validateCode = () => (
        <>
            <p className='title'>הזנת קוד אישור</p>
            <p className='greyText'>שלחנו הודעה לבעל החשבון {formatPhoneNumber(state.contactNumber)} עם קוד שיש להזין כאן</p>
            <TextInput
                ref={codeRef}
                value={state.code}
                id='code'
                placeholder='קוד אימות'
                maxLength='6'
                error={state.errorInForm}
                onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                        setState((prevState) => ({ ...prevState, code: value, errorInForm: null }));
                    }
                }}
                required
            />
            {state.needRestrictCode && (
                <TextInput
                    ref={restrictCodeRef}
                    value={state.restrictCode}
                    error={state.errorInCode}
                    id='code'
                    placeholder='קוד זיהוי'
                    onChange={(e) => setState((prevState) => ({ ...prevState, restrictCode: e.target.value }))}
                    required
                />
            )}
            <BtnSubmit text='המשך' onclick={checkOtpStep2} />
            {closePopUp}
        </>
    );

    const SendCode = () => (
        <>
            <p className='title'>{props.title}</p>
            <p className='greyText'>{props.subtitle}</p>
            <BtnSubmit text='שלחו הודעה לבעל החשבון' onclick={sendSmsToContact} />
            {closePopUp}
        </>
    );

    return <div className='OtpExtendedPopUp'>{getCurrentPopUp()}</div>;
}

const mapStateToProps = (state) => ({
    userDetails: state.authentication.loginData.userDetails,
    isOtpExtendedAuthenticated: state.authentication.loginData.isOtpExtendedAuthenticated,
});

const mapDispatchToProps = {
    createOtpLoginStep1,
    createOtpLoginStep02,
    showAppLoader,
    hideAppLoader,
    saveDumbLogin,
    refetchData,
    getSelfCareData,
};

export default connect(mapStateToProps, mapDispatchToProps)(OtpExtendedPopUp);
